// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioWide_radio__3lC2A","radioGroup":"RadioWide_radioGroup__hbIdQ","description":"RadioWide_description__FDg47","label":"RadioWide_label__2r-dK"};